module.exports = __webpack_public_path__ + "static/media/预约-小组.f8a33791.svg";